/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Billing_Board_Counts_Zero_OneInputs */



/**
* | output |
* | --- |
* | "1 of them prices to €0.00 — a free period, not a fault" |
*
* @param {Partner_Billing_Board_Counts_Zero_OneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_counts_zero_one = /** @type {((inputs?: Partner_Billing_Board_Counts_Zero_OneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Counts_Zero_OneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("1 davon ergibt 0,00 € — ein kostenloser Zeitraum, kein Fehler")
	return /** @type {LocalizedString} */ ("1 of them prices to €0.00 — a free period, not a fault")
});